module.exports = __webpack_public_path__ + "static/media/pp_approved_icon.ff07be2e.svg";